import { isEmpty } from '@sgme/fp';
import { DocumentList } from 'components/common-form/sidePanel/docToolbar/regulatory/design-system/DocumentList';
import {
  useAnalyticsCategory,
  useDocumentItems,
} from 'components/shared/Blotter/BlotterPanel/blotter-panel-document/hooks';
import { DocumentationV3 } from 'epic/common-form/Documentation';
import type { IBlotterItem } from 'models/IBlotterItem';
import { useState } from 'react';

import { BrochureDocuments } from './BrochureDocuments';
import { FinalTermsDocuments } from './FinalTermsDocuments';
import { KidDocuments } from './KidDocuments';
import { MarketingMaterialDocuments } from './MarketingMaterialDocuments';
import { PreConfirmationDocuments } from './PreConfirmationDocuments';
import { ProductGovernanceDocuments } from './ProductGovernanceDocuments';
import { TermSheetDocuments } from './TermSheetDocuments';

export interface BlotterDocumentsProps {
  documents: DocumentationV3;
  blotterItem: IBlotterItem;
}

export function BlotterDocuments({ documents, blotterItem }: BlotterDocumentsProps) {
  const analyticsCategory = useAnalyticsCategory();
  const [isCollapsed, setIsCollapsed] = useState(false);
  const {
    brochureItems,
    preConfirmationItems,
    termSheetItems,
    kidItems,
    pgItems,
    marketingMaterialItems,
    finalTermsItems,
    count,
  } = useDocumentItems(documents, blotterItem);

  if (count === 0) {
    return null;
  }

  return (
    <DocumentList count={count} isCollapsed={isCollapsed} toggleCollapse={() => setIsCollapsed(c => !c)}>
      {!isEmpty(brochureItems) && (
        <BrochureDocuments items={brochureItems} blotterItem={blotterItem} analyticsCategory={analyticsCategory} />
      )}
      {!isEmpty(preConfirmationItems) && (
        <PreConfirmationDocuments
          items={preConfirmationItems}
          blotterItem={blotterItem}
          analyticsCategory={analyticsCategory}
        />
      )}
      {!isEmpty(termSheetItems) && (
        <TermSheetDocuments items={termSheetItems} blotterItem={blotterItem} analyticsCategory={analyticsCategory} />
      )}
      {!isEmpty(kidItems) && (
        <KidDocuments items={kidItems} blotterItem={blotterItem} analyticsCategory={analyticsCategory} />
      )}
      {!isEmpty(pgItems) && (
        <ProductGovernanceDocuments items={pgItems} blotterItem={blotterItem} analyticsCategory={analyticsCategory} />
      )}
      {!isEmpty(marketingMaterialItems) && (
        <MarketingMaterialDocuments
          items={marketingMaterialItems}
          blotterItem={blotterItem}
          analyticsCategory={analyticsCategory}
        />
      )}
      {!isEmpty(finalTermsItems) && (
        <FinalTermsDocuments items={finalTermsItems} blotterItem={blotterItem} analyticsCategory={analyticsCategory} />
      )}
    </DocumentList>
  );
}
